import React, { useEffect, useMemo, useState } from "react";
import { ScrollText } from "lucide-react";
import api from "@/lib/api";
import DataTable from "@/components/app/DataTable";
import { pageSub, pageTitle } from "@/components/app/ui";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/admin/audit").then(({ data }) => setLogs(data)).finally(() => setLoading(false)); }, []);

  const columns = useMemo(() => [
    { key: "actor_email", header: "Actor", cell: (l) => <div><div className="font-medium text-neutral-900">{l.actor_email}</div><div className="text-[11px] text-slate-500 capitalize">{l.actor_role}</div></div> },
    { key: "action", header: "Action", cell: (l) => <span className="inline-block text-[11px] px-2 py-0.5 rounded-md border bg-orange-50 text-orange-700 border-orange-200 font-medium">{(l.action || "").replace(/_/g, " ")}</span> },
    { key: "module", header: "Module", hideBelow: "sm", cell: (l) => <span className="text-slate-600 capitalize">{l.module}</span> },
    { key: "record_id", header: "Record", hideBelow: "md", accessor: (l) => l.record_id || "", cell: (l) => <span className="font-mono text-[12px] text-slate-500">{(l.record_id || "").slice(0, 8) || "—"}</span> },
    { key: "created_at", header: "When", accessor: (l) => l.created_at || "", cell: (l) => <span className="font-mono text-[12px] text-slate-600 whitespace-nowrap">{(l.created_at || "").slice(0, 19).replace("T", " ")}</span> },
  ], []);

  return (
    <div className="space-y-4" data-testid="admin-audit">
      <div>
        <h1 className={pageTitle}>Audit Logs</h1>
        <p className={pageSub}>Sensitive platform actions, most recent first.</p>
      </div>
      <DataTable testId="audit-table" exportName="audit-logs" columns={columns} data={logs} loading={loading} rowKey="id"
        searchKeys={["actor_email", "action", "module", "record_id"]} searchPlaceholder="Search actor, action, record…"
        filters={[{ key: "action", label: "All actions", accessor: (l) => l.action }, { key: "module", label: "All modules", accessor: (l) => l.module }, { key: "role", label: "All roles", accessor: (l) => l.actor_role }]}
        dateField={{ label: "When", accessor: (l) => l.created_at }} defaultSort={{ key: "created_at", dir: "desc" }}
        emptyIcon={ScrollText} emptyTitle="No audit entries yet" emptyText="Sensitive actions such as suspensions and impersonation are recorded here." />
    </div>
  );
}
